import {
    FormControl,
    InputLabel,
    Select,
    MenuItem,
    Checkbox,
    ListItemText,
    FormHelperText, Box, TextField, InputAdornment
} from "@mui/material";
import { useState } from "react";
import CloseIcon from '@mui/icons-material/Close';

export default function MultiSelectWithAll({
    name,
    label,
    options = [],           // always an array
    value = [],             // always an array of objects
    onChange,
    error = false,          // always boolean
    formHelperText = "",    // always string
    disabled = false,       // always boolean
}) {
    const allValues = options; // full objects

    const handleChange = (e) => {
        const { value: newValue } = e.target;

        let updatedValues = [];

        if (newValue.includes("ALL")) {
            if (value.length === allValues.length) {
                // 🔹 Unselect all
                updatedValues = [];
            } else {
                // 🔹 Select all (store objects)
                updatedValues = allValues;
            }
        } else {
            // 🔹 Map selected IDs back to objects
            updatedValues = options.filter((opt) =>
                newValue.includes(opt.value)
            );
        }

        if (onChange) {
            onChange(name, updatedValues);
        }
    };

    const isAllSelected = value.length === options.length;

    const [searchOption, setSearchOption] = useState("");


    return (
        <FormControl fullWidth size="small" error={Boolean(error)}>
            <InputLabel id={`${name}-label`}>{label}</InputLabel>
            <Select
                labelId={`${name}-label`}
                id={`${name}-select`}
                label={label}
                multiple
                MenuProps={{
                    autoFocus: false,  // ✅ prevents dropdown from auto-scrolling
                    PaperProps: {
                        sx: {
                            maxHeight: 240,
                            minWidth: 160,
                            padding: 0,
                        }
                    },
                    MenuListProps: {
                        sx: {
                            py: 0
                        }
                    }
                }}
                disabled={disabled}
                // ensure always array of strings
                value={Array.isArray(value) ? value.map((opt) => opt.value) : []}
                onChange={handleChange}
                renderValue={(selectedVals) => {
                    if (selectedVals.length === options.length) {
                        return "Select All";
                    }
                    return options
                        .filter((opt) => selectedVals.includes(opt.value))
                        .map((opt) => opt.label)
                        .join(", ");
                }}
            >

                {/* <Box sx={{ px: 1, py: 1 }}>
                    <TextField
                        size="small"
                        placeholder="Search..."
                        fullWidth
                        value={searchOption}
                        onChange={(e) => setSearchOption(e.target.value)}
                        InputProps={{
                            endAdornment: (
                                <InputAdornment position="end">
                                    <CloseIcon
                                        onClick={() => setSearchOption("")}
                                        sx={{ cursor: "pointer" }}
                                    />
                                </InputAdornment>
                            ),
                        }}
                        // Important: prevent Select menu from closing
                        onMouseDown={(e) => e.stopPropagation()}
                        onClick={(e) => e.stopPropagation()}
                        onFocus={(e) => e.stopPropagation()} // ensures input stays focused
                    />
                </Box> */}


                <MenuItem value="ALL">
                    <Checkbox
                        checked={isAllSelected}
                        indeterminate={value.length > 0 && !isAllSelected}
                    />
                    <ListItemText primary="Select All" />
                </MenuItem>

                {options.map((opt) => (
                    <MenuItem key={opt.value} value={opt.value}>
                        <Checkbox
                            checked={value.some((v) => v.value === opt.value)}
                        />
                        <ListItemText primary={opt.label} />
                    </MenuItem>
                ))}
            </Select>
            {error && formHelperText && (
                <FormHelperText>{formHelperText}</FormHelperText>
            )}
        </FormControl>
    );
}

